import { render, staticRenderFns } from "./restrictionStrategyList.vue?vue&type=template&id=319c63a0"
import script from "./restrictionStrategyList.vue?vue&type=script&lang=js"
export * from "./restrictionStrategyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports